export default "__VITE_ASSET__ef48e6eb__"